import React, {Fragment, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import date from 'date-and-time';

import Instrucciones from '../../../Escritorio/Instrucciones';
import BotoneraBottom from '../../Compartidos/BotoneraBottom';
import useConfigAuth from '../../../../Hooks/useConfigAuth';

import { aumentarContadorSecundarioAction } from '../../../../actions/botoneraEjercicioActions';
import { almacenarAction } from '../../../../actions/almacenarEjercicioActions';
import { finalizarEjercicioAction } from '../../../../actions/estadoEjercicioActions';

import { Flex, FlexM20, FlexCuz, NumDec, NumXL, NumUni, NumAyudaM30B, ButtonAyuda, ButtonNum, DivNum, CentenaM30B } from '../../../Css/StyledMatematica';

const data2 = [
    {id:'1', numero:10},
    {id:'2', numero:20},
    {id:'3', numero:30},
    {id:'4', numero:40},
    {id:'5', numero:50},
    {id:'6', numero:60},
    {id:'7', numero:70},
    {id:'8', numero:80},
    {id:'9', numero:90}
]

const PracticaCentena = (props) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [config] = useConfigAuth();

    const { ejercicio, data, instrucciones, miniInstrucciones } = props;

    const [comparar, setComparar] = useState([]);
    const [comparar2, setComparar2] = useState([]);
    const [decena, setDecena] = useState(0);
    const [centena, setCentena] = useState(0);
    const [decenaAyuda, setDecenaAyuda] = useState(false);
    const [centenaAyuda, setCentenaAyuda] = useState(false);
    const [numeroUnidad, setNumeroUnidad] = useState([]);
    const [numeroDecena, setNumeroDecena] = useState([]);
    const [numeroCentena, setNumeroCentena] = useState([]);
    const [ayuVisual, setAyuVisual] = useState(false);
    const [ayuVisualSolicitada, setAyuVisualSolicitada] = useState(false);
    const [contarTiempo, setContarTiempo] = useState([]);
    const [idOrden, setIdOrden] = useState([]);
    const [erroresOrden, setErroresOrden] = useState([]);

    const iniciar = useSelector(state => state.ejercicio.iniciar);
    const finalizar = useSelector(state => state.ejercicio.finalizar);
    const contadorSecundario = useSelector(state => state.ejercicio.contadorSecundario);
    const id_paciente = useSelector((state) => state.usuario.id_paciente);
    const lista = useSelector(state => state.ejercicio.lista);
    const lista_usada = useSelector(state => state.informacion.lista_usada);
    const error = useSelector(state => state.ejercicio.error);
    const sesion = useSelector((state) => state.ejercicio.sesion);

    const indexes = Object.keys(data).length;

    const setearAyuVisual = (e) => {
        e.preventDefault();
        if (ayuVisual) {
            setAyuVisual(false);
        } else {
            setAyuVisual(true);
        }
        if(ayuVisualSolicitada){
            return;
        } else {
            setAyuVisualSolicitada(true);
        }
    }

    const setearCentenaAyuda = (e) => {
        e.preventDefault();
        if(centenaAyuda !== true){
            setCentenaAyuda(true);
        } else {
            setCentenaAyuda(false);
        }
        if(ayuVisualSolicitada === false){
            setAyuVisualSolicitada(true);
        }
    }
    const setearDecenaAyuda = (e) => {
        e.preventDefault();
        if(decenaAyuda !== true){
            setDecenaAyuda(true);
        } else {
            setDecenaAyuda(false);
        }
        if(ayuVisualSolicitada === false){
            setAyuVisualSolicitada(true);
        }
    }

    useEffect(() => {
        const min = Math.ceil(100);
        const max = Math.floor(1000);
        const numero = () => Math.floor(Math.random() * (max - min + 1)) + min;
        const array = Array.from({length: indexes}, () => numero());
        setNumeroUnidad(array.map(unidad => unidad.toString().substring(2,3)));
        setNumeroDecena(array.map(decena => decena.toString().substring(1,2)));
        setNumeroCentena(array.map(centena => centena.toString().substring(0,1)));
        setDecena(array.map(decena => decena.toString().substring(1,2)+'0'));
        setCentena(array.map(centena => centena.toString().substring(0,1)+'00'));
        setComparar(data);
        setComparar2(data2);
        setIdOrden(array);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if(indexes === 0){
            return;
        }
        if(contadorSecundario < indexes) {
            return;
        } else {
            dispatch( finalizarEjercicioAction() )
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contadorSecundario]);

    useEffect(() => {
        if(contadorSecundario === 0){
            return;
        }
        if(contadorSecundario === 1){
            setErroresOrden([...erroresOrden, error]);
            return;
        }
        const err = error - erroresOrden.reduce((partialSum, a) => partialSum + a, 0);
        setErroresOrden([...erroresOrden, err]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contadorSecundario])

    useEffect(() => {
        if(iniciar === false && contadorSecundario === indexes ){
            return;
        }else if(iniciar === false && contadorSecundario === 0){
            return;
        } else {
            const newList = JSON.parse(JSON.stringify(contarTiempo));
            newList.push(new Date());
            setContarTiempo(newList);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [iniciar,contadorSecundario]);

    useEffect(() => {
        if(finalizar === true && contadorSecundario === indexes -1 ){
            dispatch(aumentarContadorSecundarioAction());
        }
        if(finalizar && contadorSecundario === indexes ){
            const tiempo = JSON.parse(JSON.stringify(contarTiempo));
            const conseguirTiempos = (a) => {
                const t = [];
                for (let i = 0; i < a.length - 1; i++){
                    const despues = new Date(a[i+1]);
                    const antes = new Date(a[i])
                    const segundos = Math.round((date.subtract(despues, antes).toSeconds())*10)/10;
                    t.push(segundos);
                }
                return t
            }
            const tiempoFinal = conseguirTiempos(tiempo);

            const err = error - erroresOrden.reduce((partialSum, a) => partialSum + a, 0);
            const erroresOrdenFinal = [...erroresOrden, err];

            const informacion = {
                config,
                payload: {
                    'ejercicio': ejercicio,
                    'lista': lista,
                    'errores': error,
                    'tiempo': tiempoFinal,
                    'id_paciente': id_paciente,
                    'lista_usada': lista_usada,
                    'ayuda_visual': ayuVisualSolicitada,
                    'idOrden': idOrden,
                    'erroresOrden': erroresOrdenFinal,
                    sesion
                }
            }
            dispatch( almacenarAction(informacion) );
            navigate("/escritorio/metodos/finalizar-ejercicio");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [finalizar, contadorSecundario]);

    return (
        <Fragment>
            {iniciar
                ?
                <Flex direction="column" height="100%" width="100%">
                    <Flex direction="column" margin="auto" width="100%">
                        <div>
                            {centenaAyuda &&
                            <Flex Flex height='50vh' margin='0vh 0px 0px 0px'>
                                <Flex direction='column'>
                                    <ButtonNum
                                        onClick={(e) => setearCentenaAyuda(e)}
                                    >
                                        C
                                    </ButtonNum>
                                    <NumXL color='#23AAAF' w='69vw' wm='70vw' wt='55vw' wd='37vw' wlg='28vw' onClick={(e) => setearCentenaAyuda(e)}>
                                        {centena[contadorSecundario]}
                                    </NumXL>
                                </Flex>
                            </Flex>
                            }
                            {decenaAyuda &&
                            <Flex Flex height='50vh' margin='0vh 0px 0px 0px'>
                                <Flex direction='column'>
                                    <ButtonNum
                                        onClick={(e) => setearDecenaAyuda(e)}
                                    >
                                        D 
                                    </ButtonNum>
                                    <NumXL onClick={(e) => setearDecenaAyuda(e)} color='#FF9B2A' w='56vw' wm='42vw' wt='34vw' wd='28vw' wlg='21vw'>
                                        {decena[contadorSecundario]}
                                    </NumXL>
                                </Flex>
                            </Flex>
                            }
                            {decenaAyuda || centenaAyuda ? null :
                            <Flex Flex height='50vh' margin='0vh 0px 0px 0px'>
                                <Flex direction='column'>
                                    <ButtonNum
                                        onClick={(e) => setearCentenaAyuda(e)}
                                    >
                                        C 
                                    </ButtonNum>
                                    <CentenaM30B onClick={(e) => setearCentenaAyuda(e)}>
                                        {numeroCentena[contadorSecundario]}
                                    </CentenaM30B>
                                </Flex>
                                <Flex direction='column' margin='0vh 0vw 0vh -25vw' mm='0vh 0vw 0vh -10vw' mt='0vh 0vw 0vh -10vw' md='0vh 0vw 0vh -10vw' mlg='0vh 0vw 0vh -10vw'>
                                    <ButtonNum
                                        onClick={(e) => setearDecenaAyuda(e)}
                                    >
                                        D
                                    </ButtonNum>
                                    <NumDec onClick={(e) => setearDecenaAyuda(e)}>
                                        {numeroDecena[contadorSecundario]}
                                    </NumDec>
                                </Flex>
                                <Flex direction='column' margin='0vh 0vw 0vh -25vw' mm='0vh 0vw 0vh -10vw' mt='0vh 0vw 0vh -10vw' md='0vh 0vw 0vh -10vw' mlg='0vh 0vw 0vh -10vw'>
                                    <DivNum>
                                        U
                                    </DivNum>
                                    <NumUni>
                                        {numeroUnidad[contadorSecundario]}
                                    </NumUni>
                                </Flex>
                            </Flex>
                            }
                        </div>
                        <FlexM20 margin='16vh 0px 0vh 0px'>
                            <ButtonAyuda
                                onClick={(e) => setearAyuVisual(e)}
                            >
                                ?
                            </ButtonAyuda>
                            {ayuVisual &&
                            <FlexM20 direction='column' position='absolute' margin='0vh 0vw 0vh -1vw'>
                                <Flex>
                                    {comparar2.map(item => 
                                    <NumAyudaM30B key={item.id}>{item.numero}</NumAyudaM30B>
                                    )}
                                </Flex>
                                <Flex>
                                    {comparar.map(item => 
                                    <NumAyudaM30B key={item.id}>{item.numero}</NumAyudaM30B>
                                    )}
                                </Flex>
                            </FlexM20>
                            }
                        </FlexM20>
                    </Flex>
                    <Flex margin="0 0rem 0 0rem" width="90%" justify="space-between">
                        <Flex>
                            <BotoneraBottom miniInstrucciones={miniInstrucciones} />
                        </Flex>
                        <Flex>
                            <BotoneraBottom error={true} aumentarSecundario={true} />
                        </Flex>
                    </Flex>
                </Flex>
                :
                <Instrucciones instrucciones={instrucciones} />
            }
        </Fragment>
    );
}
 
export default PracticaCentena;